import * as d3 from 'd3';
import Tooltip from './Tooltip';

export default class StackedBubbleChart {
  constructor({
    target, data, vars, plot = { colorPalette: [] },
  }) {
    this.target = d3.select(target);
    this.data = data;
    this.numVar = vars.num;
    this.labelVar = vars.label;
    this.legendVar = vars.legend;
    this.colorPalette = plot.colorPalette;
    this.scales = {
      radius: null,
      color: null,
    };
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.offset = 10;
    // Sort data
    this.data.sort((a, b) => b[this.numVar] - a[this.numVar]);
  }

  updateDimensions() {
    this.plotOuterWidth = this.target.node().parentNode.offsetWidth;
  }

  draw() {
    this.updateDimensions();
    this.tooltip = new Tooltip(this.target.node().parentNode);

    this.stackPlot = this.target.append('g')
      .attr('class', 'stack')
      .attr('transform', `translate(${(this.plotOuterWidth / 4) + this.offset}, 0)`);

    this.legendPlot = this.target.append('g')
      .attr('class', 'legend')
      .attr('transform', `translate(${(this.plotOuterWidth / 2) + (2.2 * this.offset)}, 0)`);

    if (Array.isArray(this.colorPalette)) {
      if (this.colorPalette) {
        this.scales.color = d3.scaleOrdinal().range(this.colorPalette);
      } else {
        this.scales.color = d3.scaleOrdinal(d3.schemeCategory10);
      }
    } else {
      this.scales.color = () => this.colorPalette;
    }

    this.scales.radius = d3.scaleLinear()
      .range([0, this.plotOuterWidth / 4])
      .domain([0, d3.max(this.data, (d) => d[this.numVar])]);

    this.update();
  }

  update() {
    this.target.on('click', () => {
      const { target } = d3.event;
      this.stackPlot.selectAll('circle').attr('fill', (d, i) => this.scales.color(i));
      if (!target.matches('circle')) {
        this.handleClick();
        return;
      }
      d3.select(target).attr('fill', '#8ab9c4');
      const datum = d3.select(target).datum();
      this.handleClick(datum);
    });

    const self = this;
    const bubbles = this.stackPlot.selectAll('g').data(this.data);
    const legend = this.legendPlot.selectAll('g').data(this.data);

    const bubblesEnter = bubbles.enter().append('g')
      .merge(bubbles)
      .attr('transform', (d, i) => this.shift(d, i));

    const legendEnter = legend.enter().append('g')
      .merge(bubbles)
      .attr('transform', (d, i) => this.shift(d, i));

    bubblesEnter.append('circle')
      .attr('fill', (d, i) => this.scales.color(i))
      .attr('r', (d) => this.scales.radius(d[this.numVar]) + this.offset)
      .style('cursor', 'pointer')
      .on('mouseover', function getValue() {
        const datum = d3.select(this).datum();
        self.handleMouseOver(datum);
      })
      .on('mousemove', this.handleMouseMove)
      .on('mouseleave', this.handleMouseLeave);

    bubblesEnter.append('text')
      .text((d) => d[this.labelVar])
      .style('pointer-events', 'none')
      .attr('fill', '#F7FAFC')
      .attr('text-anchor', 'middle');

    legendEnter.append('text')
      .text((d) => d[this.legendVar])
      .attr('fill', '#2d3142')
      .call(this.wrap, (this.plotOuterWidth / 2) - 20);

    bubbles.exit().remove();

    const { height } = this.stackPlot.node().getBoundingClientRect();
    this.target.attr('viewBox', `0 0 ${this.plotOuterWidth} ${height}`);
  }

  shift(d, i) {
    if (i === 0) {
      return `translate(0, ${this.offset + this.scales.radius(d[this.numVar])})`;
    }
    let shift = 0;
    for (let j = i - 1; j >= 0; j -= 1) {
      shift += (2 * this.scales.radius(this.data[j][this.numVar])) + (4 * this.offset);
    }
    const yTranslate = shift + this.scales.radius(d[this.numVar]);
    return `translate(0, ${yTranslate})`;
  }

  // eslint-disable-next-line class-methods-use-this, no-unused-vars
  handleClick(datum) {}

  // eslint-disable-next-line class-methods-use-this, no-unused-vars
  handleMouseOver(datum) {}

  handleMouseMove() {
    const x = d3.event.offsetX;
    const y = d3.event.offsetY;
    this.tooltip.updatePosition(x, y);
  }

  handleMouseLeave() {
    this.tooltip.html('').hide();
  }

  // eslint-disable-next-line class-methods-use-this
  wrap(text, width) {
    text.each(function calculateWrapper() {
      let line = [];
      const selection = d3.select(this);
      const words = selection.text().split(/\s+/).reverse();
      let tspan = selection.text(null).append('tspan');
      let word = words.pop();
      while (word) {
        line.push(word);
        tspan.text(line.join(' '));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(' '));
          line = [word];
          tspan = selection.append('tspan')
            .attr('dy', '1rem')
            .attr('x', 0)
            .text(word);
        }
        word = words.pop();
      }
    });
  }
}
